import { render } from "./moh333.vue?vue&type=template&id=a5b2cee0&scoped=true"
import script from "./moh333.vue?vue&type=script&lang=js"
export * from "./moh333.vue?vue&type=script&lang=js"

import "./moh333.vue?vue&type=style&index=0&id=a5b2cee0&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b2cee0"]])

export default __exports__